import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

/**
 * Whether someone is signed in on this device, from the stored session and
 * auth changes — for what is mounted outside App (AppUpdater), so it needs
 * none of useAuth's refresh and recovery handling. False until it knows.
 */
export function useSignedIn(): boolean {
  const [signedIn, setSignedIn] = useState(false)
  useEffect(() => {
    let live = true
    void supabase.auth.getSession().then(({ data: { session } }) => { if (live) setSignedIn(!!session) })
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_, session) => setSignedIn(!!session))
    return () => {
      live = false
      subscription.unsubscribe()
    }
  }, [])
  return signedIn
}
